import { render, staticRenderFns } from "./FudaoTeacherEndInviteDialog.vue?vue&type=template&id=2b7bfce4&"
import script from "./FudaoTeacherEndInviteDialog.vue?vue&type=script&lang=js&"
export * from "./FudaoTeacherEndInviteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports